import { Button, Panel, Row, Well } from 'react-bootstrap';
import styled from 'styled-components';
import { FormGroupWrapper } from '@nkr/views/donors/donor-intake/styles';

export const CenterGridWrapper = styled.div`
    width: 99.9%;
    height: 56vh;

    border-right: 1px solid #ccc;

    .ag-pinned-left-header {
        border-right: 1px solid white;
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    div.ag-root .ag-cell-focus {
        user-select: text !important;
    }

    .list-cell {
        // border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #ccc;
        border-width: 0px 1px 1px 1px;
        // font-size: 12px;
    }

    .list-cell:nth-child(1) {
        border-left: 0 none;
    }

    .list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
    }

    .list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-left: 1px solid white;
    }

    .list-header:nth-child(1) {
        border-left: 1px solid #ddd;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    .donor-connect-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-connect-drop-down > .ag-react-container {
        width: 100%;
    }

    .ag-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    
    .label {
        font-size: 90%
    }

    @media screen and (width < 1680px) {
        font-size: 12px;

        .label {
            font-size: 75%;
        }
    }
`;

export const AdminGridWrapper = styled(CenterGridWrapper)`
    height: 53vh;

    .label {
        font-size: 75%
    }
`

export const DocumentButton = styled(Button)`
    //min-width: 250px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    // margin-bottom: 8px;
    
    .button-content {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .status-icon {
        font-size: 14px;
        margin-left: 12px;
        opacity: 0.8;
    }

    &.btn-primary {
        &:not(:disabled) {
            &:hover, &:focus {
                background-color: #0056b3;
                border-color: #004085;
            }
        }
    }

    &:disabled {
        opacity: 1;
        background-color: #e9ecef;
        border-color: #dee2e6;
        color: #adb5bd;
        cursor: not-allowed;

        &:hover, &:focus {
            background-color: #e9ecef;
            border-color: #dee2e6;
        }

        .status-icon {
            opacity: 0.5;
        }

        .button-content {
            opacity: 0.7;
        }
    }
`;

export const ActionButton = styled(Button)`
    min-width: 250px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;

    &.btn-primary {
        &:hover, &:focus {
            background-color: #0056b3;
            border-color: #004085;
        }
    }
`;

export const DocumentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    // margin-bottom: 20px;
`;

export const SectionTitle = styled.h4`
    margin-top: 12px;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 2px solid #e9ecef;
    color: #495057;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.2;

    &:first-of-type {
        margin-top: 0;
    }
`;

export const ReadOnlyField = styled(Row)`
    margin: 0;
    padding: 2px 0;
    min-height: 24px;
    border-bottom: 1px solid #f8f9fa;
    
    label {
        color: #495057;
        font-weight: 600;
        margin: 0;
        line-height: 20px;
    }

    .field-value {
        color: #212529;
        line-height: 20px;
    }

    .text-muted {
        color: #6c757d;
        font-style: italic;
    }
`;

export const PanelBodyWrapper = styled(Panel.Body)`
    padding: 12px 15px;
`;

export const FormSection = styled.div`
    margin-bottom: 15px;
    padding-bottom: 12px;
    border-bottom: 1px solid #dee2e6;

    &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
    }

    ${FormGroupWrapper} {
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const FormField = styled(FormGroupWrapper)`
    margin-bottom: 10px;
    
    label {
        padding-top: 7px;
    }
`;

export const FilterWrapper = styled(Well)`
    margin-bottom: 5px;
    
    .form-group {
        margin-bottom: 10px;
    }

    label {
        margin-bottom: 0px;
    }
`